/* Maison Lumelle — collection page controller (client-side filter/sort/paginate on server-rendered cards) */
(function () {
  'use strict';

  function init(root) {
    root = root || document;
    var section = root.querySelector('.lumelle-catalogue');
    if (!section) return;
    var wrap = section.querySelector('.lumelle-gridwrap');
    var grid = section.querySelector('.lumelle-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.lumelle-card'));
    var resp = Array.prototype.slice.call(grid.querySelectorAll('.lumelle-resp'));
    var batch = parseInt(section.getAttribute('data-batch') || '24', 10);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var toolbar = document.querySelector('.lumelle-toolbar');
    var countEl = toolbar ? toolbar.querySelector('[data-count]') : null;

    var state = { tab: 'Tous', inStock: false, min: null, max: null, sort: 'default', shown: batch };
    var defMin = parseInt(section.getAttribute('data-min') || '0', 10);
    var defMax = parseInt(section.getAttribute('data-max') || '99999', 10);

    function q(s, el) { return (el || document).querySelector(s); }
    function qa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

    function cardData(c) {
      return {
        el: c,
        style: c.getAttribute('data-style') || '',
        price: parseFloat(c.getAttribute('data-price') || '0'),
        stock: c.getAttribute('data-stock') === '1',
        created: parseInt(c.getAttribute('data-created') || '0', 10),
        rank: parseInt(c.getAttribute('data-rank') || '0', 10)
      };
    }
    var model = cards.map(cardData);

    function compute() {
      var min = state.min == null ? defMin : state.min;
      var max = state.max == null ? defMax : state.max;
      var filtered = model.filter(function (p) {
        return (state.tab === 'Tous' || p.style === state.tab)
          && (!state.inStock || p.stock)
          && p.price >= min && p.price <= max;
      });
      var sorters = {
        'default': function (a, b) { return a.rank - b.rank; },
        'Nouveautés': function (a, b) { return b.created - a.created; },
        'Prix croissant': function (a, b) { return a.price - b.price; },
        'Prix décroissant': function (a, b) { return b.price - a.price; },
        'Meilleures ventes': function (a, b) { return a.rank - b.rank; }
      };
      filtered.sort(sorters[state.sort] || sorters['default']);
      return filtered;
    }

    function apply() {
      var filtered = compute();
      var total = filtered.length;
      var visible = filtered.slice(0, state.shown);

      model.forEach(function (p) {
        var idx = visible.indexOf(p);
        if (idx >= 0) {
          p.el.style.display = '';
          p.el.style.order = String(idx * 2);
        } else {
          p.el.style.display = 'none';
        }
      });

      var full = (state.tab === 'Tous' && !state.inStock && state.min == null && state.max == null);
      resp.forEach(function (r) {
        var after = parseInt(r.getAttribute('data-after') || '8', 10);
        if (full && visible.length > after) {
          r.style.display = '';
          r.style.order = String((after * 2) - 1);
        } else {
          r.style.display = 'none';
        }
      });

      if (countEl) countEl.textContent = total + (total === 1 ? ' pièce' : ' pièces');

      var emptyEl = section.querySelector('.lumelle-empty');
      if (emptyEl) emptyEl.style.display = total === 0 ? '' : 'none';
      grid.style.display = total === 0 ? 'none' : 'grid';

      var vp = section.querySelector('.lumelle-voirplus-wrap');
      if (vp) vp.style.display = total === 0 ? 'none' : 'flex';
      var btn = section.querySelector('.lumelle-voirplus');
      if (btn) btn.style.display = visible.length < total ? '' : 'none';
      var bar = section.querySelector('.lumelle-progress-bar');
      var lbl = section.querySelector('.lumelle-progress-label');
      var pct = total ? Math.round((visible.length / total) * 100) : 0;
      if (bar) bar.style.width = pct + '%';
      if (lbl) lbl.textContent = visible.length + (visible.length === 1 ? ' pièce sur ' : ' pièces sur ') + total;

      qa('.lumelle-tab').forEach(function (t) {
        var name = t.getAttribute('data-tab');
        var uw = t.querySelector('.lumelle-tab-uw');
        if (uw) uw.style.width = state.tab === name ? '100%' : '0%';
      });
    }

    function change(patch) {
      if (wrap && !reduced) {
        wrap.style.opacity = '0';
        setTimeout(function () {
          Object.assign(state, { shown: batch }, patch);
          apply();
          requestAnimationFrame(function () { wrap.style.opacity = '1'; });
        }, 300);
      } else {
        Object.assign(state, { shown: batch }, patch);
        apply();
      }
    }

    qa('.lumelle-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        var name = t.getAttribute('data-tab');
        if (state.tab !== name) change({ tab: name });
      });
    });

    var sortBtn = document.querySelector('.lumelle-sort-btn');
    var sortMenu = document.querySelector('.lumelle-sortmenu');
    var sortLabelEl = document.querySelector('.lumelle-sort-label');
    if (sortBtn && sortMenu) {
      sortBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        sortMenu.style.display = sortMenu.style.display === 'block' ? 'none' : 'block';
      });
      qa('.lumelle-sort-opt', sortMenu).forEach(function (o) {
        o.addEventListener('click', function () {
          var name = o.getAttribute('data-sort');
          sortMenu.style.display = 'none';
          qa('.lumelle-sort-opt', sortMenu).forEach(function (x) { x.style.color = '#262220'; });
          o.style.color = '#A98B4F';
          if (sortLabelEl) sortLabelEl.textContent = o.textContent.trim();
          if (state.sort !== name) change({ sort: name });
        });
      });
      document.addEventListener('click', function (e) {
        if (sortMenu.style.display === 'block' && !e.target.closest('.lumelle-toolbar')) sortMenu.style.display = 'none';
      });
    }

    qa('.lumelle-stock-toggle').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = !state.inStock;
        qa('.lumelle-stock-mark').forEach(function (m) { m.textContent = next ? '✓' : ''; });
        change({ inStock: next });
      });
    });

    var tmpMin = null, tmpMax = null;
    qa('.lumelle-price-min').forEach(function (i) { i.addEventListener('input', function () { tmpMin = parseInt(i.value, 10); }); });
    qa('.lumelle-price-max').forEach(function (i) { i.addEventListener('input', function () { tmpMax = parseInt(i.value, 10); }); });
    qa('.lumelle-apply-price').forEach(function (b) {
      b.addEventListener('click', function () {
        closeDrawer();
        change({ min: isNaN(tmpMin) || tmpMin == null ? null : tmpMin, max: isNaN(tmpMax) || tmpMax == null ? null : tmpMax });
      });
    });
    qa('.lumelle-clear').forEach(function (b) {
      b.addEventListener('click', function () {
        tmpMin = null; tmpMax = null;
        qa('.lumelle-price-min').forEach(function (i) { i.value = ''; });
        qa('.lumelle-price-max').forEach(function (i) { i.value = ''; });
        qa('.lumelle-stock-mark').forEach(function (m) { m.textContent = ''; });
        closeDrawer();
        change({ tab: 'Tous', inStock: false, min: null, max: null });
      });
    });

    qa('.lumelle-voirplus').forEach(function (b) {
      b.addEventListener('click', function () { state.shown += batch; apply(); });
    });

    var drawer = document.querySelector('.lumelle-drawer');
    var scrim = document.querySelector('.lumelle-scrim');
    function closeDrawer() {
      if (drawer) drawer.style.transform = 'translateX(102%)';
      if (scrim) { scrim.style.opacity = '0'; scrim.style.pointerEvents = 'none'; }
    }
    qa('.lumelle-filtrer').forEach(function (b) {
      b.addEventListener('click', function () {
        if (drawer) drawer.style.transform = 'translateX(0)';
        if (scrim) { scrim.style.opacity = '1'; scrim.style.pointerEvents = 'auto'; }
      });
    });
    qa('.lumelle-drawer-close').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (scrim) scrim.addEventListener('click', closeDrawer);

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
